import { render } from "./AdS.vue?vue&type=template&id=a8c1c240&scoped=true"
import script from "./AdS.vue?vue&type=script&lang=js"
export * from "./AdS.vue?vue&type=script&lang=js"

import "./AdS.vue?vue&type=style&index=0&id=a8c1c240&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8c1c240"]])

export default __exports__